module.exports = __webpack_public_path__ + "static/snow-border-146f0f2f97e564054ac5e9e6755714b4.svg";